import { Col } from 'components';

const Spinner = ({ fullHt, ht }) => (
  <Col center centerAll ht={ht || (fullHt ? '85vh' : '100%')}>
    <div className="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </Col>
);

export default Spinner;
